import { render } from "./Responsavel.vue?vue&type=template&id=0cd53c0e&scoped=true"
import script from "./Responsavel.vue?vue&type=script&lang=js"
export * from "./Responsavel.vue?vue&type=script&lang=js"

import "./Responsavel.vue?vue&type=style&index=0&id=0cd53c0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd53c0e"]])

export default __exports__